// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4627":"989da67312e58031","6713":"2c99373c2aee67a7"}[chunkId] + ".css";
};